module.exports = __webpack_public_path__ + "img/image-hero-whitecup.e53ed248.jpg";